module.exports = __webpack_public_path__ + "img/TopIdea.be2a3ede.png";